import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Card, Button, Form, Tabs, Tab, OverlayTrigger } from "react-bootstrap";

import { ToastContainer, toast } from 'react-toastify';
import Select from "react-select";
import { useNavigate } from "react-router-dom";


function ViewStudent() {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [students, setStudents] = useState([]);
    const [form, setForm] = useState({
        student_id: "",
        student_first_name: "",
        student_last_name: "",
        dob: "",
        blood_group_id: "",
        blood_group_name: "",
        address: "",
        city: "",
        state: "",
        state_name: "",
        country: "",
        country_name: "",
        date_of_join: "",
        date_of_exit: "",
        createdby: "",
        lastmodifiedby: "",
        image_id: "",
        class_id: "",
        class_name: "",
        section_id: "",
        section_name: "",
        roll_no: "",
        student_class_teacher_id: 0,
        student_class_teacher_name: "",
        aadhar_card_no: "",
        birth_certificate_no: "",
        gender: "",
        permanent_address: "",
        caste: "",
        religion_id: "",
        aadhar_card_upload: "",
        caste_upload: "",
        birth_certificate_upload: "",
        previous_years_tc: "",
        roll_no: "",
        passport_size_photo: "",
        academic_year_id: 0,
        academic_year_name: "",
        admission_number: "",
        mother_tongue_id: "",
        mother_tongue_name: "",
        nationality: "",
        father_occupation: "",
        mother_occupation: "",
        class_last_studied: "",
        class_name: "",
        previous_school_name: "",
        admission_to: "",
        class_name: "",
        first_language_id: "",
        first_language_name: "",
        second_language_id: "",
        second_language_name: "",
        vaccination: "",
        primary_contact: "",
        father_surname: "",
        father_firstname: "",
        mother_surname: "",
        mother_firstname: "",
        father_email: "",
        mother_email: "",
        father_phone_number: "",
        mother_phone_number: "",
        school_id: 0,
        password: "",
        father_aadhar_number: "",
        father_aadhar_upload: "",
        mother_aadhar_number: "",
        mother_aadhar_upload: "",
        sibling1: "",
        sibling2: "",
        sibling3: "",
        third_language_id: "",
        third_language_name: "",
        student_info: "",
        sibling1_name: "",
        sibling1_phone: "",
        sibling1_date: "",
        sibling2_name: "",
        sibling2_phone: "",
        sibling2_date: "",
        sibling3_name: "",
        sibling3_phone: "",
        sibling3_date: "",
        sibling1_id: "",
        sibling2_id: "",
        sibling3_id: "",
        teacher_id: "",
        India: "India",
        first_language_name: "",
        second_language_name: "",
        third_language_name: "",
        previous_school_percentage: "",
        permanent_education_number: "",
        date_of_admission: "",
        mole_1: "",
        mole_2: "",
        residential_proof: "",
        medium: "",
        class_of_leaving_id: "",
        tc_upload: "",
        reason_of_leaving: "",
        date_of_tc_issued: "",
        which_school_student_has_gone: "",
        primary_language_id: "",
        primary_language: "",
        sports_certificate: "",
        blood_group_certificate: "",
        record_sheet_date: "",
        record_sheet_upload: "",
        record_sheet_submitted: "",
        remarks: "",
        apaar_number: "",
        tc_number: "",
    })
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [editId, setEditId] = useState(null);
    const routeLocation = useLocation();


    useEffect(() => {
        if (routeLocation.state?.userData) {
            const userData = routeLocation.state.userData;
            setForm(userData);
            setEditId(userData.student_id);
            window.history.replaceState({}, document.title);
        }
    }, [routeLocation]);

    useEffect(() => {
        fetchStudents(form.student_id || 0);
    }, [form.student_id]);

    const fetchStudents = async () => {
        try {
            const response = await axios.post(baseUrl + "/students/", {
                action: "READ",
            });
            setStudents(response.data);
        } catch (error) {
            console.error("Error fetching students:", error);
        }
    };

    const formatDate1 = (datetime) => {
        if (!datetime) return "";
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const navigate = useNavigate();

 const handlePrint = () => {
    const printableContent = document.querySelector('.pageBody').cloneNode(true);
    const buttons = printableContent.querySelectorAll('button');
    buttons.forEach(button => button.remove());

   
    const printContainer = document.createElement('div');
    printContainer.className = 'print-container';

 
    const rows = printableContent.querySelectorAll('.row > div');

    let currentSection = '';
    let currentFields = [];

    
    rows.forEach(row => {
        
        const sectionHeader = row.querySelector('u');
        if (sectionHeader) {
            
            if (currentFields.length > 0) {
                addSectionToPrint(printContainer, currentSection, currentFields);
                currentFields = [];
            }
            currentSection = sectionHeader.textContent.trim();
        } else {
           
            const fields = row.querySelectorAll('.commonInput');
            fields.forEach(field => {
                currentFields.push(field.cloneNode(true));
            });
        }
    });

   
    if (currentFields.length > 0) {
        addSectionToPrint(printContainer, currentSection, currentFields);
    }

    const printStyles = `
        <style>
            @page { size: auto; margin: 10mm; }
            body { 
                font-family: Arial; 
                margin: 20px; 
                line-height: 1.5; 
            }
            .print-section {
                margin-bottom: 20px;
                page-break-inside: avoid;
                break-inside: avoid;
            }
            .section-header {
                font-weight: bold;
                text-decoration: underline;
                margin: 20px 0 15px; 
                padding-bottom: 5px;
                width: 100%;
                line-height: 1.6; 
            }
            .print-row {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-bottom: 10px; 
            }
            .print-field {
                width: 48%;
                display: flex;
                margin-bottom: 12px; 
                line-height: 1.5; 
            }
            .form-label {
                font-weight: bold;
                min-width: 120px;
                margin-right: 5px;
            }
            .print-title {
                text-align: center;
                margin-bottom: 25px; 
                font-size: 1.5em;
                line-height: 1.6; 
            }
        </style>
    `;

    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(`
        <html>
            <head>
                <title>Student Details - ${form.student_first_name} ${form.student_last_name}</title>
                ${printStyles}
            </head>
            <body>
                <div class="print-title">Student Details</div>
                ${printContainer.innerHTML}
                <script>
                    window.onload = function() {
                        setTimeout(function() {
                            window.print();
                            window.close();
                        }, 200);
                    };
                </script>
            </body>
        </html>
    `);
    printWindow.document.close();

    
    function addSectionToPrint(container, sectionName, fields) {
        const sectionDiv = document.createElement('div');
        sectionDiv.className = 'print-section';
        
        const header = document.createElement('div');
        header.className = 'section-header';
        header.textContent = sectionName;
        sectionDiv.appendChild(header);
        
        const fieldsContainer = document.createElement('div');
        
        
        for (let i = 0; i < fields.length; i += 2) {
            const row = document.createElement('div');
            row.className = 'print-row';
            
            const field1 = fields[i];
            field1.className = 'print-field';
            row.appendChild(field1);
            
            if (fields[i + 1]) {
                const field2 = fields[i + 1];
                field2.className = 'print-field';
                row.appendChild(field2);
            }
            
            fieldsContainer.appendChild(row);
        }
        
        sectionDiv.appendChild(fieldsContainer);
        container.appendChild(sectionDiv);
    }
};

    return (
        <>
            
               
               
                    <div className="pageBody">
                         <ToastContainer />
                        <Container fluid>
                            <Card>
                                <Card.Body className="hide-scrollbar" >
                                    <form>
                                        <Row>
                                           <div className="d-flex justify-content-end gap-2">
    <Button
        variant="primary"
        className="btn-sm p-1"
        style={{ minWidth: "80px" }} 
        onClick={handlePrint}
    >
        Print
    </Button>
    <Button
        variant="primary"
        className="btn-sm p-1 secondaryBtn"
        onClick={() => navigate("/students")}
    >
        Cancel
    </Button>
</div>

                                            <Row>
                                                <u><b>Student Details</b></u>&nbsp;
                                            </Row>
                                            <Col xs={12} md={6} lg={4} xxl={3}  >
                                                <div className="commonInput">
                                                    <span className="form-label"> Admission Number:</span>
                                                    <span className="">{form.admission_number}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Surname:
                                                    </span>
                                                    <span className="">
                                                        {form.student_last_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        First Name:
                                                    </span>
                                                    <span className="">
                                                        {form.student_first_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        DOB:
                                                    </span>
                                                    <span className="">
                                                        {formatDate1(form.dob)}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        DOJ:
                                                    </span>
                                                    <span className="">
                                                        {formatDate1(form.date_of_join)}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Gender:
                                                    </span>
                                                    <span className="">
                                                        {form.gender}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Primary Contact:
                                                    </span>
                                                    <span className="">
                                                        {form.primary_contact}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Blood Group:
                                                    </span>
                                                    <span className="">
                                                        {form.blood_group_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Mole 1:</span>
                                                    <span className="">{form.mole_1}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Mole 2:</span>
                                                    <span className="">{form.mole_2}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Medium:</span>
                                                    <span className="">{form.medium}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Vaccination:
                                                    </span>
                                                    <span className="">
                                                        {form.vaccination}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        DOE:
                                                    </span>
                                                    <span className="">
                                                        {form.date_of_exit}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">APAAR Number:</span>
                                                    <span className="">{form.apaar_number}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Permanent Education Number:
                                                    </span>
                                                    <span className="">
                                                        {form.permanent_education_number}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Row>
                                                <u><b>Class Details</b></u>&nbsp;
                                            </Row>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Academic Year:
                                                    </span>
                                                    <span className="">
                                                        {userObj.academic_year_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Date of Admission:</span>
                                                    <span className="">{formatDate1(form.date_of_admission)}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Admission To:
                                                    </span>
                                                    <span className="">
                                                        {form.next_joining_class_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Class:
                                                    </span>
                                                    <span className="">
                                                        {form.class_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Section:
                                                    </span>
                                                    <span className="">
                                                        {form.section_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Class Teacher:
                                                    </span>
                                                    <span className="">
                                                        {form.student_class_teacher_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Roll Number:
                                                    </span>
                                                    <span className="">
                                                        {form.roll_no}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Class of Leaving:</span>
                                                    <span className="">{form.class_of_leaving}</span>
                                                </div>
                                            </Col>
                                            <Row>
                                                <u><b>ID Details</b></u>&nbsp;
                                            </Row>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Aadhar Number:
                                                    </span>
                                                    <span className="">
                                                        {form.aadhar_card_no}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Caste:
                                                    </span>
                                                    <span className="">
                                                        {form.caste}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Birth Certificate Number:
                                                    </span>
                                                    <span className="">
                                                        {form.birth_certificate_no}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Nationality:
                                                    </span>
                                                    <span className="">
                                                        {form.nationality}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Religion:
                                                    </span>
                                                    <span className="">
                                                        {form.religion_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Mother Tongue:</span>
                                                    <span className="">{form.mother_tongue_name}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">TC Number:</span>
                                                    <span className="">{form.tc_number}</span>
                                                </div>
                                            </Col>
                                            <Row>
                                                <u><b>Previous School</b></u>&nbsp;
                                            </Row>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Previous School:
                                                    </span>
                                                    <span className="">
                                                        {form.previous_school_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Previous Class:
                                                    </span>
                                                    <span className="">
                                                        {form.class_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        First Language:
                                                    </span>
                                                    <span className="">
                                                        {form.first_language_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Second Language:
                                                    </span>
                                                    <span className="">
                                                        {form.second_language_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Third Language:
                                                    </span>
                                                    <span className="">
                                                        {form.third_language_name}
                                                    </span>
                                                </div>
                                            </Col>

                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Previous School Percentage:
                                                    </span>
                                                    <span className="">
                                                        {form.previous_school_percentage}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Row>
                                                <u><b>Father Details</b></u>&nbsp;
                                            </Row>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Father Name:
                                                    </span>
                                                    <span className="">
                                                        {form.father_firstname + " " + form.father_surname}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Father Contact:
                                                    </span>
                                                    <span className="">
                                                        {form.father_phone_number}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Father Email:
                                                    </span>
                                                    <span className="">
                                                        {form.father_email}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Father Aadhar Number:
                                                    </span>
                                                    <span className="">
                                                        {form.father_aadhar_number}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Father Occupation:
                                                    </span>
                                                    <span className="">
                                                        {form.father_occupation}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Row>
                                                <u><b>Mother Details</b></u>&nbsp;
                                            </Row>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Mother Name:
                                                    </span>
                                                    <span className="">
                                                        {form.mother_firstname + " " + form.mother_surname}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Mother Contact:
                                                    </span>
                                                    <span className="">
                                                        {form.mother_phone_number}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Mother Email:
                                                    </span>
                                                    <span className="">
                                                        {form.mother_email}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Mother Aadhar Number:
                                                    </span>
                                                    <span className="">
                                                        {form.mother_aadhar_number}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Mother Occupation:
                                                    </span>
                                                    <span className="">
                                                        {form.mother_occupation}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Row>
                                                <u><b>Guardian Details</b></u>&nbsp;
                                            </Row>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Guardain Name:
                                                    </span>
                                                    <span className="">
                                                        {form.guardian_firstname + " " + form.guardian_surname}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Guardain Contact:
                                                    </span>
                                                    <span className="">
                                                        {form.guardian_phone_number}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Guardain Email:
                                                    </span>
                                                    <span className="">
                                                        {form.guardian_email}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Guardain Aadhar Number:
                                                    </span>
                                                    <span className="">
                                                        {form.guardian_aadhar_number}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Guardain Occupation:
                                                    </span>
                                                    <span className="">
                                                        {form.guardian_occupation}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Row>
                                                <u><b>Location Details</b></u>&nbsp;
                                            </Row>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        City:
                                                    </span>
                                                    <span className="">
                                                        {form.city}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        State:
                                                    </span>
                                                    <span className="">
                                                        {form.state_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Country:
                                                    </span>
                                                    <span className="">
                                                        {form.country_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Address:
                                                    </span>
                                                    <span className="">
                                                        {form.address}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Permanent Address:
                                                    </span>
                                                    <span className="">
                                                        {form.permanent_address}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Row>
                                                <u><b>Sibling Details</b></u>&nbsp;
                                            </Row>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Sibling 1:
                                                    </span>
                                                    <span className="">
                                                        {form.sibling1_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Sibling 2:
                                                    </span>
                                                    <span className="">
                                                        {form.sibling2_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">
                                                        Sibling 3:
                                                    </span>
                                                    <span className="">
                                                        {form.sibling3_name}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Row>
                                                <u><b>Other Details</b></u>&nbsp;
                                            </Row>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Reason of Leaving:</span>
                                                    <span className="">{form.reason_of_leaving}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Date of TC Issueed:</span>
                                                    <span className="">{formatDate1(form.date_of_tc_issued)}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Primary Language:</span>
                                                    <span className="">{form.primary_language}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Record Sheet Date:</span>
                                                    <span className="">{formatDate1(form.record_sheet_date)}</span>
                                                </div>
                                            </Col>

                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Record Sheet Submitted:</span>
                                                    <span className="">{form.record_sheet_submitted}</span>
                                                </div>
                                            </Col>
                                            <Col xs={12} md={6} lg={4} xxl={3}>
                                                <div className="commonInput">
                                                    <span className="form-label">Remarks:</span>
                                                    <span className="">{form.remarks}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </form>
                                </Card.Body>
                            </Card>
                        </Container>
                    </div>
                
           
        </>
    );
};
export default ViewStudent;